import { Heading } from '@mm/components';
import { ArrowRightOutlined } from '@ant-design/icons';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';
import { OnboardingSignupStep } from '@mm/state/model/CompanyUsersModel';
import { isFacebookUserSelector } from '@mm/state/selectors/userSelector';
import { selectActiveFacebookPage } from '@mm/state/selectors/facebookPageSelector';
import { ChannelInfo } from '../../../../../../../../editor/features/beta/modules/Automations/AutomationHome/TemplateIndex/TemplateGoButton';
import { AutomationTemplateChannel } from '../../../../../../../../editor/features/beta/modules/Automations/AutomationHome/TemplateIndex/Templates/TemplateDefinitions';
import { ReactComponent as DiamondIcon } from './diamond.svg';
import styles from './ConnectChannels.module.css';
import { useChannelConnection } from '../../../../../../../../editor/features/beta/modules/Automations/AutomationEdit/InputTriggers/use-channel-connection';
import { useSetNextOnboardingStep } from '../../../../../use-set-next-onboarding-step';

export const ConnectChannels = () => {
  const { setNextOnboardingStep } = useSetNextOnboardingStep();
  const audienceExtractorChannel = useRef<'instagram' | 'facebook' | undefined>(
    undefined,
  );
  const chatbotId = useSelector(
    (state: StoreState) => state.chatbot.basicListByCompany[0]?.id,
  );
  const activeBotId = useSelector(selectActiveFacebookPage)?.activeBotId;
  const isFBUser = useSelector(isFacebookUserSelector);
  const { connectChannel, isSMSSupported } = useChannelConnection(
    () =>
      setNextOnboardingStep(
        OnboardingSignupStep.NONE,
        false,
        audienceExtractorChannel.current,
      ),
    chatbotId || activeBotId,
    true,
  );

  const doNextStep = channel =>
    isFBUser && channel === 'facebook'
      ? setNextOnboardingStep(OnboardingSignupStep.NONE, false, channel)
      : connectChannel(channel);

  const channels = isSMSSupported
    ? ['instagram', 'facebook', 'sms', 'email']
    : ['instagram', 'facebook', 'email'];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <DiamondIcon />
        <Heading size={2} className={styles.heading}>
          Congratulations!{' '}
        </Heading>
        <div className={styles.text}>
          Choose the first Messaging Channel for your Automation.
        </div>
        <div className={styles.text}>
          Don’t worry — you can add more inputs later.
        </div>
      </div>
      <div className={styles.buttonsWrapper}>
        {channels.map((channel: AutomationTemplateChannel) => {
          return (
            <div
              className={styles.button}
              key={channel}
              onClick={() => {
                if (channel === 'facebook' || channel === 'instagram') {
                  audienceExtractorChannel.current = channel;
                }
                doNextStep(channel);
              }}
            >
              <ChannelInfo channel={channel} width={35} height={35} />
            </div>
          );
        })}
      </div>
      <div
        className={styles.link}
        onClick={() =>
          setNextOnboardingStep(
            OnboardingSignupStep.NONE,
            false,
            isFBUser ? 'facebook' : undefined,
          )
        }
      >
        Skip for now
        <ArrowRightOutlined className={styles.arrowIcon} />
      </div>
    </div>
  );
};
